/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FlightSegment } from './FlightSegment';
import {
    FlightSegmentFromJSON,
    FlightSegmentFromJSONTyped,
    FlightSegmentToJSON,
    FlightSegmentToJSONTyped,
} from './FlightSegment';
import type { Pricing } from './Pricing';
import {
    PricingFromJSON,
    PricingFromJSONTyped,
    PricingToJSON,
    PricingToJSONTyped,
} from './Pricing';
import type { FlightType } from './FlightType';
import {
    FlightTypeFromJSON,
    FlightTypeFromJSONTyped,
    FlightTypeToJSON,
    FlightTypeToJSONTyped,
} from './FlightType';
import type { Direction } from './Direction';
import {
    DirectionFromJSON,
    DirectionFromJSONTyped,
    DirectionToJSON,
    DirectionToJSONTyped,
} from './Direction';

/**
 * General information about flight package. Contains information about feeder/main flight inside flightSegments
 * @export
 * @interface Flight
 */
export interface Flight {
    /**
     * Code needed to book a flex flight
     * @type {string}
     * @memberof Flight
     */
    code?: string;
    /**
     * 
     * @type {FlightType}
     * @memberof Flight
     */
    type: FlightType;
    /**
     * 
     * @type {Direction}
     * @memberof Flight
     */
    direction: Direction;
    /**
     * Departure airport code
     * @type {string}
     * @memberof Flight
     */
    depAirportCode?: string;
    /**
     * Departure airport date. The format is defined as "YYYY-MM-DD" (ISO 8601)
     * @type {string}
     * @memberof Flight
     */
    depDate?: string;
    /**
     * Arrival airport code
     * @type {string}
     * @memberof Flight
     */
    arrAirportCode?: string;
    /**
     * Arrival date. The format is defined as "YYYY-MM-DD" (ISO 8601)
     * @type {string}
     * @memberof Flight
     */
    arrDate?: string;
    /**
     * Flight class
     * @type {string}
     * @memberof Flight
     */
    flightClassCode?: string;
    /**
     * Name of flight class
     * @type {string}
     * @memberof Flight
     */
    flightClassName?: string;
    /**
     * List of pricings. The sorting corresponds to the sorting of the guests/paxe
     * @type {Array<Pricing>}
     * @memberof Flight
     */
    pricings: Array<Pricing>;
    /**
     * List of flight segments
     * @type {Array<FlightSegment>}
     * @memberof Flight
     */
    flightSegments?: Array<FlightSegment>;
}



/**
 * Check if a given object implements the Flight interface.
 */
export function instanceOfFlight(value: object): value is Flight {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('direction' in value) || value['direction'] === undefined) return false;
    if (!('pricings' in value) || value['pricings'] === undefined) return false;
    return true;
}

export function FlightFromJSON(json: any): Flight {
    return FlightFromJSONTyped(json, false);
}

export function FlightFromJSONTyped(json: any, ignoreDiscriminator: boolean): Flight {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'type': FlightTypeFromJSON(json['type']),
        'direction': DirectionFromJSON(json['direction']),
        'depAirportCode': json['depAirportCode'] == null ? undefined : json['depAirportCode'],
        'depDate': json['depDate'] == null ? undefined : json['depDate'],
        'arrAirportCode': json['arrAirportCode'] == null ? undefined : json['arrAirportCode'],
        'arrDate': json['arrDate'] == null ? undefined : json['arrDate'],
        'flightClassCode': json['flightClassCode'] == null ? undefined : json['flightClassCode'],
        'flightClassName': json['flightClassName'] == null ? undefined : json['flightClassName'],
        'pricings': ((json['pricings'] as Array<any>).map(PricingFromJSON)),
        'flightSegments': json['flightSegments'] == null ? undefined : ((json['flightSegments'] as Array<any>).map(FlightSegmentFromJSON)),
    };
}

export function FlightToJSON(json: any): Flight {
    return FlightToJSONTyped(json, false);
}

export function FlightToJSONTyped(value?: Flight | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'type': FlightTypeToJSON(value['type']),
        'direction': DirectionToJSON(value['direction']),
        'depAirportCode': value['depAirportCode'],
        'depDate': value['depDate'],
        'arrAirportCode': value['arrAirportCode'],
        'arrDate': value['arrDate'],
        'flightClassCode': value['flightClassCode'],
        'flightClassName': value['flightClassName'],
        'pricings': ((value['pricings'] as Array<any>).map(PricingToJSON)),
        'flightSegments': value['flightSegments'] == null ? undefined : ((value['flightSegments'] as Array<any>).map(FlightSegmentToJSON)),
    };
}

